export const planetChartData = {
    type: "bar",
    data: {
        labels: ["Africa", "Asia", "Europe", "Latin America", "North America"],
        datasets: [{
            label: "Population (millions)",
            backgroundColor: [
                "#000066",
                "#800080",
                "#490bd3",
                "#ff00ff",
                "#20b2aa"
            ],
            data: [2478, 5267, 734, 784, 433]
        }]
    },
    options: {
        legend: {
            display: false
        },
        title: {
            display: true,
            text: "Predicted world population (millions) in 2050"
        }
    }
}

export const lineChartData = {
    type: "line",
    data: {
        labels: [1500, 1600, 1700, 1750, 1800, 1850, 1900, 1950, 1999, 2050],
        datasets: [{
                data: [86, 114, 106, 106, 107, 111, 133, 221, 783, 2478],
                label: "Africa",
                borderColor: "#000066",
                fill: false
            },
            {
                data: [282, 350, 411, 502, 635, 809, 947, 1402, 3700, 5267],
                label: "Asia",
                borderColor: "#800080",
                fill: false
            },
            {
                data: [168, 170, 178, 190, 203, 276, 408, 547, 675, 734],
                label: "Europe",
                borderColor: "#490bd3",
                fill: false
            },
            {
                data: [40, 20, 10, 16, 24, 38, 74, 167, 508, 784],
                label: "Latin America",
                borderColor: "#0c3fcb",
                fill: false
            },
            {
                data: [6, 3, 2, 2, 7, 26, 82, 172, 312, 433],
                label: "North America",
                borderColor: "#0ccb98",
                fill: false
            }
        ]
    },
    options: {
        title: {
            display: true,
            text: "World population per region (in millions)"
        }
    }
}

export const barChartData = {
    type: "horizontalBar",
    data: {
        labels: [
            "Africa",
            "Asia",
            "Europe",
            "Latin America",
            "North America"
        ],
        datasets: [{
            label: "Population (millions)",
            backgroundColor: [
                "#b266b2",
                "#800080",
                "#0c9fcb",
                "#000066",
                "#0ccb98"
            ],
            data: [2478, 5267, 734, 784, 433]
        }]
    },
    options: {
        legend: {
            display: false
        },
        title: {
            display: true,
            text: "Predicted world population (millions) in 2050"
        }
    }
}
export const bubbleChartData = {
    type: "bubble",
    data: {
        labels: "Africa",
        datasets: [{
                label: ["China"],
                backgroundColor: "#800080",
                borderColor: "#800080",
                data: [{
                    x: 21269017,
                    y: 5.245,
                    r: 15
                }]
            },
            {
                label: ["Denmark"],
                backgroundColor: "#000066",
                borderColor: "#000066",
                data: [{
                    x: 258702,
                    y: 7.526,
                    r: 10
                }]
            },
            {
                label: ["Germany"],
                backgroundColor: "#ff00ff",
                borderColor: "#000",
                data: [{
                    x: 3979083,
                    y: 6.994,
                    r: 15
                }]
            },
            {
                label: ["Japan"],
                backgroundColor: "#0ccb98",
                borderColor: "#20b2aa",
                data: [{
                    x: 4931877,
                    y: 5.921,
                    r: 15
                }]
            }
        ]
    },
    options: {
        title: {
            display: true,
            text: "Predicted world population (millions) in 2050"
        },
        scales: {
            yAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: "Happiness"
                }
            }],
            xAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: "GDP (PPP)"
                }
            }]
        }
    }
}

export default { planetChartData, lineChartData, barChartData, bubbleChartData };